import React, { ReactElement } from "react";
import { Link, Box, styled, BoxProps } from "@mui/material";
import ArrowForwardIcon from "@mui/icons-material/ArrowForward";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import { TypographyProps } from "@mui/material/Typography";

const StyledLink = styled(Link)<{ textColor?: string }>(
  ({ theme, color = "link" }) => ({
    display: "inline-block",
    color:
      color === "secondary"
        ? theme.palette.text.secondary
        : theme.palette.primary.main,
  })
);

const MoreButtonText = styled("span")(({ theme }) => ({
  display: "flex",
  alignItems: "center",
  gap: theme.spacing(1),
  cursor: "pointer",
}));

export interface LinkWithArrowProps extends Omit<BoxProps, "onClick"> {
  href?: string;
  onClick?: (event: React.MouseEvent<HTMLAnchorElement>) => void;
  text: string;
  variant?: TypographyProps["variant"];
  testId?: string;
  color?: string;
  direction?: "forward" | "back";
  target?: string;
  icon?: ReactElement;
}

export const LinkWithArrow = ({
  href,
  onClick,
  direction = "forward",
  text,
  testId,
  color,
  icon,
  variant = "body1",
  target,
  ...rest
}: LinkWithArrowProps) => {
  return (
    <Box {...rest}>
      <StyledLink
        href={href}
        onClick={onClick}
        variant={variant}
        data-testid={testId}
        target={target}
        color={color}
      >
        <MoreButtonText>
          {direction === "back"
            ? icon || <ArrowBackIcon fontSize="inherit" />
            : null}
          {text}
          {direction === "forward"
            ? icon || <ArrowForwardIcon fontSize="inherit" />
            : null}
        </MoreButtonText>
      </StyledLink>
    </Box>
  );
};
